import React from 'react'
import { Button, Modal, ModalBody } from 'reactstrap';
import "./ModalAutorizacion.css";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SpinnerModal from '../SpinnerModal/SpinnerModal';
import { estiloColorError, estilosModal, estiloFiltroEncabezados } from '../../../Services/PaletaDeColores';

export default class ModalEliminarCotizacion extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show: props.show,
      titulo: props.titulomodal,

      colormsgerror: estiloColorError().msgerror,
      estilosmodal: estilosModal(),
      colortitulo: estiloFiltroEncabezados().colortitulos,

      txtpassword: "",
      vermsgerrortxtpassword: false,
      msgerrortxtpassword: "",

      txtprincipal: "",
      vermsgerrortxtprincipal: false,
      msgerrortxtprincipal: "",

      tarjetaeliminar: this.props.item,

    }

  }
  async componentDidMount() {
    
  }

  showModal = (accion) => {
    this.setState({ show: false });
    setTimeout(() => {
      this.props.cerrarModal(accion);
    }, 200);
  }

  eliminarItem = async () => {
    this.props.cerrarModal(this.props.item);
  }


  render() {
    return (

      <>
        {(this.state.loadingspinners == true) ? (
          <SpinnerModal tipo="full" show={this.state.loadingspinners} />
        ) : null}

        <ToastContainer />

        <Modal isOpen={this.state.show}
          size="md"
          aria-labelledby=""
          centered>
          <ModalBody>
            <div className="divTituloModal">
              <label className="modalLblTitulo letraTitulos" style={{ color: this.state.colortitulo }} >{this.state.titulo}</label>
            </div>

            <br />

            <div className="divModalEliminar">
              <div className="divContenedorModal" style={{ backgroundColor: this.state.estilosmodal.fondocontenedormodal, boxSizing: "content-box" }}>
                <div className='row'>
                  <div className='col-4'>
                    <label className='lblSubTitulosModal letraTitulos' style={{ color: this.state.colortitulo }}>Proveedor:</label>
                  </div>
                  <div className='col-8'>
                    <label className='lblSubTitulosModal letraTitulos' style={{ color: this.state.estilosmodal.colorlblsubtitulosmodal }}>{this.props.item.proveedor}</label>
                  </div>

                  <div className='col-4'>
                    <label className='lblSubTitulosModal letraTitulos' style={{ color: this.state.colortitulo }}>Productos:</label>
                  </div>
                  <div className='col-8'>
                    <label className='lblSubTitulosModal letraTitulos' style={{ color: this.state.estilosmodal.colorlblsubtitulosmodal }}>{this.props.item.productos.length} Artículos</label>
                  </div>

                  <div className='col-4'>
                    <label className='lblSubTitulosModal letraTitulos' style={{ color: this.state.colortitulo }}>Total:</label>
                  </div>
                  <div className='col-8'>
                    <label className='lblSubTitulosModal letraTitulos' style={{ color: this.state.estilosmodal.colorlblsubtitulosmodal }}>${this.props.item.total}</label>
                  </div>

                </div>
              </div>
            </div>

            <div className="divBtnContenedorModal" >
              <Button className="btnCancelModal" onClick={() => this.showModal('0')}>Cancelar</Button>
              <Button className="btnAceptarModal" onClick={() => this.eliminarItem()} >Continuar</Button>
            </div>

          </ModalBody>

        </Modal>
      </>
    )
  }
}
